import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Custom hook for profile data
 * Provides memoized user details from Redux state
 * @returns {Object} User information and computed values
 */
export const useProfileData = () => {
  const userDetails = useSelector((state) => state?.userDetails?.details);
  const userType = useSelector((state) => state?.userType?.type);

  // Memoize profile type - use userType or fallback to Title
  const profileType = useMemo(() => {
    return userType !== "Other" ? userType : userDetails?.Title || "---";
  }, [userType, userDetails?.Title]);

  // Memoize mobile number with fallback
  const mobileNumber = useMemo(() => {
    return userDetails?.MobilePhone || "---";
  }, [userDetails?.MobilePhone]);

  // Memoize image URL
  const imageUrl = useMemo(() => {
    const photoBase64 = userDetails?.Photo__c;
    return photoBase64 ? `data:image/png;base64,${photoBase64}` : null;
  }, [userDetails?.Photo__c]);

  return {
    userDetails,
    profileType,
    mobileNumber,
    imageUrl,
    hasPhoto: Boolean(userDetails?.Photo__c),
  };
};
